export default "__VITE_ASSET__b6216324__"